<script lang="ts">
	import { DropdownMenu as DropdownMenuPrimitive } from 'bits-ui'

	let { ref = $bindable(null), ...restProps }: DropdownMenuPrimitive.GroupProps = $props()
</script>

<DropdownMenuPrimitive.Group data-slot="dropdown-menu-group" bind:ref {...restProps} />
